/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
/* eslint-disable @typescript-eslint/naming-convention */

const types = {
  GoogleServer: {
    config: Symbol.for("Types.GoogleServer.Config"),
  },
  GoogleClient: {
    config: Symbol.for("Types.GoogleClient.Config"),
  },
};

export { types as Types };
